import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const Footer = () => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
    <Typography variant="caption">&copy; iomarket 2024</Typography>
    <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">
      <Link component={RouterLink} to="https://www.io-market.com/" target="_blank" variant="caption" color="textPrimary">
        <FormattedMessage id="aboutUs"></FormattedMessage>
      </Link>
      <Link component={RouterLink} to="https://accounts.io-market.net/#/privacy-policy" variant="caption" color="textPrimary">
      <FormattedMessage id="privacy"></FormattedMessage>
      </Link>
      <Link component={RouterLink} to="https://accounts.io-market.net/#/termsandcondition" variant="caption" color="textPrimary">
      <FormattedMessage id="terms"></FormattedMessage>
      </Link>
      <Link component={RouterLink} to="https://accounts.io-market.net/#/legal-notices" variant="caption" color="textPrimary">
      <FormattedMessage id="imprint"></FormattedMessage>
      </Link>
    </Stack>
  </Stack>
);

export default Footer;
